package com.exura.features.plandefinition.data.mappers.plandefinition

import com.exura.features.plandefinition.data.remote.dto.element.BasePlanElementDto
import com.exura.features.plandefinition.domain.model.element.BasePlanElement
import dev.gitlive.firebase.firestore.CollectionReference

/**
 * Base interface for all series mappers.
 * Extends SerializableMappers for Firebase storage compatibility.
 *
 * @param T The specific BaseSeries implementation type
 * @param D The specific BaseSeriesDto implementation type
 */
class PolymorphicElementMappers : PlanElementMappers<BasePlanElement, BasePlanElementDto> {
    override fun toDto(model: BasePlanElement): BasePlanElementDto = model.toDto()

    override fun toDomain(
        dto: BasePlanElementDto,
        collection: CollectionReference?,
        id: String?
    ): BasePlanElement = dto.toDomain(collection, id)
}
